export const GUEST = 'guest'
export const USER = 'user'
export const ADMIN = 'admin'


export const LOCAL_STORAGE_ROLES = "AD-PANEL-ROLES";
export const LOCAL_STORAGE_TOKEN = "AD-PANEL-TOKEN";
export const PIXEL_BATCH_SECRET = "panel-pixel-batch-2026";

export const API_URL = "https://preview-panel-fdf6a38f55c0.herokuapp.com"
export const PIXEL_API_URL =  "https://test-pixel-tdxz.onrender.com";
//export const API_URL = "http://localhost:5000"
//export const API_URL = "https://main-panel.onrender.com";

